/**
 * 효과음 카탈로그 — 정본은 sfxCatalog.json(분류 → 소리 줄). 전부 실녹음 mp3 다(합성음 없음).
 *
 * 파일 경로는 id 에서 나온다 — `combat.impact.hit` → `/audio/sfx/combat_impact_hit.mp3`.
 * gain = 그 소리만의 크기 보정(없으면 1). 소스: Sonniss GDC 2026 번들(로열티프리·표기 불필요),
 * 어느 원본을 잘랐는지는 scripts/asset_pipeline/make_sfx_oneshots.py 의 JOBS 표.
 * 배경음 창의 삭제 버튼(개발 서버 전용)이 이 JSON 줄과 mp3 를 같이 지운다 — 지운 id 를 부르면 소리 없이 넘어간다.
 */
import SFX_JSON from './sfxCatalog.json';

/** [{ key, label, desc, items:[{ id, label, full?, gain? }] }] — full = 칸에 안 들어가는 원래 이름(팝오버). 배경음 창 효과음 목록이 이 차례로 그린다. */
export const SFX_GROUPS = SFX_JSON;

/** id → { gain? } */
export const SOUND_CATALOG = Object.fromEntries(
  SFX_JSON.flatMap((g) => g.items.map((it) => [it.id, it.gain != null ? { gain: it.gain } : {}])),
);

// 스킬 형태(skillCatalog.type) → 시전음 id. 실제 카탈로그는 광역을 `aoe_self`·`aoe_target` 으로 쓴다.
const CAST_BY_SHAPE = {
  target: 'combat.cast.target',
  spread: 'combat.cast.spread',
  linear: 'combat.cast.linear',
  aoe: 'combat.cast.aoe',
  chain: 'combat.cast.linear',
  aoe_self: 'combat.cast.aoe',
  aoe_target: 'combat.cast.aoe',
};

export function castSoundFor(shape) {
  return CAST_BY_SHAPE[shape] || 'combat.cast.target';
}
